import {Node, NodeType} from "../../../model/Graph";
import {getVoMetadata} from "./get-vo-metadata";
import {isListVo} from "./is-list-vo";

export const isStateVo = (node: Node): boolean => {
  if(node.getType() !== NodeType.document) {
    return false;
  }

  if(isListVo(node)) {
    return false;
  }

  const meta = getVoMetadata(node);

  return !!meta.entity;
}
